export default {
  UNKNOWN: -1,
  INVALID_RESPONSE: -2,
  AUTH_INVALID_TOKEN: 9000,
  AUTH_INVALID_REFRESH_TOKEN: 9003
};
